;!$(function(){

	// 主导航
	function t1mainNavFn(){
		$(".t1-first-menu").hover(function(){
			$(this).find(".t1-second-panel").stop().slideDown(200);
		},function(){
			$(this).find(".t1-second-panel").stop().slideUp(200);
		});
	}
	t1mainNavFn();

	// 副导航2
	function t1ViceNavFn2(){
		//获取副导航导航项
		var viceNav = $(".t1-vice-nav");
		var viceNav2 = $(".t1-vice-nav-2");
		var viceNav2Menu = viceNav2.find(".t1-menu");
		viceNav2.find(".t1-menu-hd").click(function(){
			$(this).siblings(".t1-menu-bd").slideToggle(300);
			return false;
		});
	}
	t1ViceNavFn2();

	// 副导航3
	function t1ViceNavFn3(){
		var viceNav = $(".t1-vice-nav");
		var viceNav3 = $(".t1-vice-nav-3");
		var viceNav3Menu = viceNav3.find(".t1-menu");
		viceNav3Menu.hover(function(){
			$(this).addClass("t1-current")
			       .find(".t1-menu-bd").show();
		},function(){
			$(this).removeClass("t1-current")
			       .find(".t1-menu-bd").hide();
		});
	}
	t1ViceNavFn3();

	//商品直通车（设置商品直通车dl列表高度）
	function t1CommodityTrainFn1(){
		//纵向商品直通车 dl 的高度等于他父元素的内高度
		var linkList1 = $(".t1-link-list-1");
		linkList1.find("dl").height(linkList1.innerHeight() - 40 + "px");
	}
	t1CommodityTrainFn1();


	//商品直通车（设置商品直通车dl列表高度）
	function t1CommodityTrainFn2(){
		//窗口大小变化时，横向排列商品直通车 dt 高度等于他直接父元素 dl 的高度
		var linkList2 = $(".t1-link-list-2");
		$(window).resize(function(){
			linkList2.find("dt").each(function(){
				$(this).height($(this).parents("dl").height());
			});
		}).resize();
	}
	t1CommodityTrainFn2();



	// 页签切换
	function t1TabToggleFn(){
		var tab = $(".t1-tab");
		var switchable = tab.find(".t1-switchable");
		switchable.click(function(){
			var parent = $(this).parents(".t1-tab");
			var inx = parent.find(".t1-switchable").index($(this));
			$(this).addClass("t1-current").siblings(".t1-switchable").removeClass("t1-current");
			parent.find(".t1-tab-panel").hide().eq(inx).show();
		});
		switchable.eq(0).click();
	}
	t1TabToggleFn();

	// 点击用户评论里的回复按钮时,显示回复面板,再次点击隐藏
	function t1CommentFn(){
		var comment = $(".t1-comment");
		var interact = comment.find(".t1-interact");
		interact.find(".t1-fore2").click(function(){
			var parent = $(this).parents("li");
			parent.find(".t1-input-group").slideToggle(200);
		});
	}
	t1CommentFn();

	//面包屑导航,部分页面面包屑有查看更多按钮
	//鼠标悬停时显示下拉面板,离开时隐藏下拉面板
	function t1CrumbFn(){
		var crumb = $(".t1-crumb");
		var moreCase = crumb.find(".t1-more-case");
		moreCase.hover(function(){
			$(this).find(".t1-more-case-bd").stop().slideDown(150);
		},function(){
			$(this).find(".t1-more-case-bd").stop().slideUp(150);
		});
	}
	t1CrumbFn();


	$("#getcode_gg").click(function() {
		$(this).attr("src", 'Tools/code/code_gg.php?' + Math.random());
	});
	$("#chk_gg").click(function() {

	});
	$(".yxorder-wrap input[type='text'],.yxorder-wrap textarea").blur(function() {
		var msg = $(this).attr('msg') ? $(this).attr('msg') : '请正确输入!';
		var pattern = $(this).attr('pattern');
		var label = $(this).parent().siblings('.row-hd').html();
		if (label) {
			label = label.replace("：", '');
		}

		if ($(this).attr('required')) {
			var requiredReturn = required($(this).val(), label);
			if (!requiredReturn.flog) {
				$(this).siblings('.nsw-formtipbd').find('span').show().html(requiredReturn.msg);
				return false;
			}
		}
		if ($(this).val() !== '') {
			var returnInfo = verify().run(pattern, $(this).val(), msg);
			if (!returnInfo.flog) {
				$(this).siblings('.nsw-formtipbd').find('span').show().html(returnInfo.msg);
				return false;
			} else {
				$(this).siblings('.nsw-formtipbd').find('span').hide();
				return true;
			}
		}
	});
	var ts = $('.rowcon .tijaobd').append(" <b></b>");
	var time = 0;
	$(".tijaobd input").click(function() {
		kuayu();

	});
	var jshi = function jshi(time) {
		if (time > 0) {
			time--;
			ts.find("b").html("请" + time + "秒后再次提交！");
			$('.rowcon .tijaobd input[type="button"]').attr("disabled", "disabled");
			setTimeout(function() {
				jshi(time);
			}, 1000)

		} else {
			ts.find("b").html("");
			$('.rowcon .tijaobd input[type="button"]').removeAttr("disabled");
		}
	}

	var verify = function verify() {
		//console.log($("input[type='text']"));
		var service = {
			run: function run(type, value, msg) {
				switch (type) {
					case 'phone':
						return checkPhone(value);
						break;
					case 'email':
						return checkEmail(value);
						break;
					case 'number':
						return checkNumber(value);
						break;
					case '':
						return required(value);
						break;
					default:
						return checkReg(type, value, msg);
						break;
				}
			}
		};
		return service;
	};

	function checkPhone(value) {
		var phone = /^(13[0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/;
		return {
			flog: phone.test(value),
			msg: '请填写正确的手机号码！'
		};
	}

	function chechEmail(value) {
		var email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
		return {
			flog: email.test(value),
			msg: '请填写正确的email！'
		};
	}

	function checkReg(type, value, msg) {
		var reg = new RegExp(type);
		return {
			flog: reg.test(value),
			msg: msg
		};
	}

	function required(value, lable) {
		if (!value.length) {
			return {
				flog: false,
				msg: lable + '不能为空！'
			}
		} else {
			return {
				flog: true
			}
		}
	}

	//提交
	function kuayu() {
		var code_gg = $("#code_gg").val();
		var codegg = false;

		$.ajax({
			type: "post",
			url: "/Tools/code/chk_code.php?act=gg",
			data: "code=" + code_gg,
			async: false,
			success: function(msg) {
				if (msg == 1) {
					codegg = true;
					$("#getcode_gg").attr("src", 'Tools/code/code_gg.php?' + Math.random());
				} else {
					nsw.showTip("验证码错误!");
					$("#getcode_gg").attr("src", 'Tools/code/code_gg.php?' + Math.random());
					codegg = false;
				}
			}
		});
		if (checkAll() && codegg) {
			var dt = $("#intentionalOrderFormId").serializeObject();
			var url = "";
			if ($("input[name='vcenter']")) {
				url = $("input[name='vcenter']").val();
			}
			$.ajax({
				'url': url + "?json=" + JSON.stringify(dt),
				'type': 'post',
				'dataType': 'jsonp',
				'jsonpCallback': 'callback',
				'error': function (data) {
					nsw.showTip("提交失败!");
					console.log(data);
				},
				'success': function(data) {
					nsw.showTip(data.msg);
					time = 30;
					jshi(time);
				}
			});

		}

	}

	//orderForm 为提交form

	//自动将form表单封装成数组
	$.fn.serializeObject = function() {
		var o = {};
		var a = this.serializeArray();
		$.each(a, function() {
			if (o[this.name]) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			} else {
				o[this.name] = this.value || '';
			}
		});
		return o;
	};

	function checkAll() {
		var isOk = true;
		$(".yxorder-wrap input[type='text'],.yxorder-wrap textarea").each(function() {
			var pattern = $(this).attr('pattern')?$(this).attr('pattern'):null;
			var label = $(this).parent().siblings('.row-hd').html();
			label = label.replace("：", '');
			if ($(this).attr('required')) {
				var requiredReturn = required($(this).val(), label);
				if (!requiredReturn.flog) {
					$(this).siblings('.nsw-formtipbd').find('span').show().html(requiredReturn.msg);
					isOk = isOk && false;
				}
			}
			if ($(this).val() !== '') {
				var returnInfo = verify().run(pattern, $(this).val());
				if (!returnInfo.flog) {
					$(this).siblings('.nsw-formtipbd').find('span').show().html(returnInfo.msg);
					isOk = isOk && false;
				} else {
					$(this).siblings('.nsw-formtipbd').find('span').hide();
					isOk = isOk && true;
				}
			}
		});
		$(".yxorder-wrap select").each(function(){
			var label = $(this).parent().siblings('.row-hd').html();
			label = label.replace("：", '');
			if ($(this).attr('required')&&$(this).val()==-1) {
				$(this).siblings('.nsw-formtipbd').find('span').show().html(label+"需要选择!");
				isOk = isOk && false;

			}
		});
		return isOk;
	}
	function addFavorite2() {
		var url = window.location;
		var title = document.title;
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf("360se") > -1) {
			alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
		} else if (ua.indexOf("msie 8") > -1) {
			window.external.AddToFavoritesBar(url, title); //IE8
		} else if (document.all) {
			try {
				window.external.addFavorite(url, title);
			} catch (e) {
				alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
			}
		} else if (window.sidebar) {
			window.sidebar.addPanel(title, url, "");
		} else {
			alert('您的浏览器不支持,请按 Ctrl+D 手动收藏!');
		}
	}
});
/**
 * Created by yaoyc on 2016/3/31.
 */
(function($) {
	"use strict";
	var $tipHtml = $('<div class="modal-body showTip"> <p>msg</p> </div>');
	//var $messageHtml=$('<div class="modal-body"> <p>msg</p> </div>');
	var $modal_wrap = $('<div class="modal-shade">');
	$modal_wrap.height($(window).height()).css({
		display: 'none',
		width: '100%',
		zIndex: 1080,
		position: 'fixed',
		top: '0px',
		left: '0px',
		minHeight: '800px'
	});
	$tipHtml.css({
		margin: "100px auto 0",
		width: "300px",
		color: "#f08300",
		background: "rgba(196,197,202,0.6)",
		lineHeight: '60px',
		height: '60px',
		padding: '0 15px',
		fontSize:"16px"
	});
	$tipHtml.find("p").css({
		textAlign: "center"
	});
	window.nsw = {
		$showModal: function showModal() {

		},
		showTip: function showTip(msg) {
			$modal_wrap.append($tipHtml);
			$tipHtml.find("p").html(msg);
			$("body").append($modal_wrap);
			$modal_wrap.fadeIn();
			setTimeout(function() {
				/* $("body").remove($(".modal_wrap"));*/
				$modal_wrap.remove();
			}, 3000)
		}
	};

})(jQuery);

function QQLink(qq){
	qq = QQ ? QQ:qq;
	window.open("http://wpa.qq.com/msgrd?v=3&uin="+qq+"&site=qq&menu=yes");
}